module.exports = __webpack_public_path__ + "img/santaclaus.4919f417.png";